import moment = require("moment");
import {none, option, Option} from "ts-option";
import {JobDetailsApiDto} from "../../api/model/rest";

export default class JobDetailsModel {
	constructor(
		public readonly executionDate: Option<moment.Moment>,
		public readonly partsPickupDate: Option<moment.Moment>,
		public readonly confirmedPartsPickupDate: Option<moment.Moment>) {}

	public static fromJson(json: JobDetailsApiDto) {
		const executionDate = json.executionDate ? option(moment(json.executionDate)) : none;
		const partsPickUpDate = json.partsPickupDate ? option(moment(json.partsPickupDate)) : none;
		const confirmedPartsPickupDate = json.confirmedPartsPickupDate ? option(moment(json.confirmedPartsPickupDate)) : none;
		return new JobDetailsModel(executionDate, partsPickUpDate, confirmedPartsPickupDate)
	}

	toJson() {
		return {
			executionDate: this.executionDate.map(date => date.format()).orNull,
			partsPickupDate: this.partsPickupDate.map(date => date.format()).orNull,
			confirmedPartsPickupDate: this.confirmedPartsPickupDate.map(date => date.format()).orNull
		}
	}

	copy({
		executionDate = this.executionDate,
		partsPickupDate = this.partsPickupDate,
		confirmedPartsPickupDate = this.confirmedPartsPickupDate
	}): JobDetailsModel {
		return new JobDetailsModel(executionDate, partsPickupDate, confirmedPartsPickupDate)
	}
}